import React from 'react';

import { styled, Typography } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { IKImage } from '../../../../components/IKImage';
import { colorsPalette } from '../../../../theme';
import { secondsToHHHmmm } from '../../../../utils/helpers';

const PathwayCard = ({ duration, title, link, videosCount, image }) => {
  const { t } = useTranslation();

  return (
    <CardWrapper to={link}>
      <Content>
        <Title variant="h3">{title}</Title>
        <Info>
          {videosCount} {t('common.videos')}
          {' • '}
          {secondsToHHHmmm(duration)}
        </Info>
      </Content>
      <Background>
        <IKImage path={image} srcset={[{ width: 500 }]} sizes="500px" />
      </Background>
    </CardWrapper>
  );
};

export default PathwayCard;

const Info = styled(Typography)({
  fontSize: 14,
  color: colorsPalette.blue,
});
const Title = styled(Typography)({
  fontSize: 20,
  marginBottom: 8,
});
const Content = styled('div')({
  position: 'relative',
  zIndex: 1,
  padding: '24px 18px',
});
const CardWrapper = styled(Link)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-end',
  height: 215,
  marginBottom: 18,
  borderRadius: 5,
  color: colorsPalette.white,
  boxShadow: `0px 3px 6px ${fade(colorsPalette.black, 0.4)}`,
  [theme.breakpoints.up('sm')]: {
    height: 180,
    marginBottom: 0,
    borderRadius: 10,
  },
}));
const Background = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  paddingBottom: 3,
  '& img': {
    borderRadius: 5,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    [theme.breakpoints.up('md')]: {
      borderRadius: 10,
    },
  },
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `linear-gradient(0deg, ${colorsPalette.blackSecondary} 0%, rgba(36, 34, 47, 0.901961) 17.24%, rgba(45, 50, 56, 0.0001) 100%)`,
    borderRadius: '0 0 5px 5px',
    [theme.breakpoints.up('md')]: {
      borderRadius: '0 0 10px 10px',
    },
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `linear-gradient(0deg, rgba(35, 32, 46, 0.5) 0%, rgba(35, 32, 46, 0.3) 100%);`,
    borderRadius: 5,
    [theme.breakpoints.up('md')]: {
      borderRadius: 10,
    },
  },
}));
